const getSearchRegexp = (query: string) => {
  const pattern = query.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
  return new RegExp(pattern, 'gi')
}

export const getHighlightMatches = (query: string) => {
  const regex = getSearchRegexp(query)
  return (value: string) => {
    const chunks = []
    let match
    while ((match = regex.exec(value))) {
      const from = match.index
      const to = regex.lastIndex
      // We do not return zero-length matches
      if (to > from) {
        chunks.push({from, to})
      }

      // Prevent browsers like Firefox from getting stuck in an infinite loop
      // See http://www.regexguru.com/2008/04/watch-out-for-zero-length-matches/
      if (match.index === regex.lastIndex) {
        regex.lastIndex++
      }
    }

    return chunks
  }
}
